import { InlineNotification } from '@carbon/react';
import { useLoadableAtomValue } from 'lib/hooks/useLoadableAtomValue';
import { SlotFormationTable } from 'components/slots-by-formation-table';
import { SlotsByFormationResponse } from 'types/api-responses';
import { packageSlotsByFormationAtom } from './atoms';

interface HorizontalSlotsByFormationProps {
  packageId: number;
}

/**
 * Self-contained component that fetches and renders the horizontal slots
 * by formation table. Includes its own loading, error, and data states.
 *
 * @param {HorizontalSlotsByFormationProps} props - Component props.
 * @return {JSX.Element} The slots by formation section.
 */
export const HorizontalSlotsByFormation = ({
  packageId,
}: HorizontalSlotsByFormationProps) => {
  const slotsByFormationData = useLoadableAtomValue<
    SlotsByFormationResponse,
    Error
  >(packageSlotsByFormationAtom(packageId));

  const isLoading = slotsByFormationData.state === 'loading';
  const hasError = slotsByFormationData.state === 'hasError';
  const slotsByFormation =
    slotsByFormationData.state === 'hasData'
      ? slotsByFormationData.data
      : undefined;

  return (
    <>
      {hasError && (
        <InlineNotification
          kind="error"
          title={slotsByFormationData.error.message}
          lowContrast
        />
      )}
      <SlotFormationTable
        horizontalSlotsByFormation={slotsByFormation}
        isLoading={isLoading}
        tableId={`package-${packageId}-slots-by-formation`}
      />
    </>
  );
};
